import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, ToastController } from '@ionic/angular';
import { TextableService } from './services/textable-service.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActionPerformed, PushNotifications, PushNotificationSchema } from '@capacitor/push-notifications';
import { SplashScreen } from '@capacitor/splash-screen';
import { FCM } from '@capacitor-community/fcm';
import log from 'loglevel';
import { SessionRevocationService } from './services/session-revocation.service';
import { AuthNZService } from './core/authnz.service';

import { ControlMessagingService } from './services/control-messaging.service';
import { ReplaySubject } from 'rxjs';
import { ApplicationStates } from './core/auth-nz/interfaces';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements AfterViewInit{

  @ViewChild("tplFullApp") tplRefFullApp: TemplateRef<any>;
  @ViewChild("tplBillingDisabled") tplRefBillingDisabled: TemplateRef<any>;
  public currentTemplate$: ReplaySubject<TemplateRef<any>> = new ReplaySubject();

  constructor(
    private platform: Platform,
    private afa: AngularFireAuth,
    private textable: TextableService,
    public toast: ToastController,
    public router: Router,
    private sessionRevocation: SessionRevocationService,
    public authnz: AuthNZService,
    public controlMessaging: ControlMessagingService
  ){}

  ngAfterViewInit(){
    this.platform.ready().then(() => {

      this.authnz.authState$.subscribe((state)=>{
        SplashScreen.hide();
        this.currentTemplate$.next(this.tplRefFullApp);
      });

      this.authnz.loggedInUserProfile$.subscribe((user)=>{
        if(user.disabledForBilling) {
          this.currentTemplate$.next(this.tplRefBillingDisabled);
        }
        else {
          this.currentTemplate$.next(this.tplRefFullApp);
        }
      });
    });
  }
}
